import type { ReferenceDataItem } from "../resources/referenceDataItem";
import type { SummaryView } from "./tenants/getTenantsOverviewBffResponse";
export interface DeploymentFreezeOverviewBffResponse {
    TotalDeploymentFreezeCount: number;
    FilteredDeploymentFreezeCount: number;
    DeploymentFreezes: DeploymentFreezeSummary[];
    Filters: DeploymentFreezeBffFilters;
}
export interface DeploymentFreezeBffFilters {
    Projects: ReferenceDataItem[];
    Environments: ReferenceDataItem[];
    Status: DeploymentFreezeStatus[];
}
export enum DeploymentFreezeStatus {
    Expired = "Expired",
    Scheduled = "Scheduled",
    Active = "Active"
}
export interface DeploymentFreezeSummary {
    Id: string;
    Name: string;
    Start: string;
    End: string;
    Status: DeploymentFreezeStatus;
    Projects: SummaryView<DeploymentFreezeOverviewProject>;
}
export interface DeploymentFreezeOverviewProject {
    Id: string;
    Name: string;
    Environments: SummaryView<DeploymentFreezeOverviewEnvironment>;
}
export interface DeploymentFreezeOverviewEnvironment {
    Id: string;
    Name: string;
}
export interface DeploymentFreezeFilterQueryParameters {
    filterByProjects: string[];
    filterByEnvironments: string[];
    filterByStatus: string[];
    filterByName: string | undefined;
    pageNumber: string;
    pageSize: string;
}
